<template>
  <el-card class="ds-detail" style="position:relative;z-index:0;width:100%">
    <div slot="header" class="clearfix">
      <span>服务器工作详情</span>
      <el-button @click="$router.back()" class="pull-right">
        <i class="fa fa-chevron-left fa-fw"></i> 返回
      </el-button>
    </div>
    <div style="margin-bottom: 15px;">
      <el-tabs type="border-card">
        <el-tab-pane label="服务器信息">
          <table border="1" bordercolor="#dedede" style="width: 100%;border-collapse:collapse;">
            <tr>
              <th width="15%">平台名称</th>
              <td width="35%">{{ item.Platform ? item.Platform.PlatformName : '-' }}</td>
              <th width="15%">在线情况</th>
              <td width="35%">
                <el-tag v-if="item.HeartBeat" type="success">在线</el-tag>
                <el-tag v-else type="danger">离线</el-tag>
              </td>
            </tr>
            <tr>
              <th>服务器类型</th>
              <td v-if="item.ServerTypes">
                <span v-for="type in item.ServerTypes.split(',')" :key="type">
                  <el-tag v-if="type === '1'" style="margin-right:10px;">业务</el-tag>
                  <el-tag v-if="type === '2'" style="margin-right:10px;">数据</el-tag>
                  <el-tag v-if="type === '3'" style="margin-right:10px;">通讯</el-tag>
                </span>
              </td>
              <th>服务器IP</th>
              <td>{{ item.IP }}</td>
            </tr>
            <tr>
              <th>CPU使用率</th>
              <td>
                {{ item.Status && item.Status.CPU
                ? parseFloat(item.Status.CPU.Busy * 100).toFixed(1) + '%'
                : '-' }}
              </td>
              <th>进程数</th>
              <td>{{ item.Status && item.Status.Procs ? item.Status.Procs.Num : '-' }}</td>
            </tr>
            <tr>
              <th>内存占用率</th>
              <td>
                {{ item.Status && item.Status.Mem
                ? parseFloat(item.Status.Mem.UsedPercent * 100).toFixed(1) + '%'
                : '' }}
              </td>
              <th>内存使用详情</th>
              <td v-if="item.Status && item.Status.Mem">
                {{ Math.round(item.Status.Mem.Used / Math.pow(1024,3)) }}G /
                {{ Math.round(item.Status.Mem.Total / Math.pow(1024,3)) }}G
              </td>
              <td v-else>-</td>
            </tr>
            <tr>
              <th>磁盘占用率</th>
              <td>
                {{ item.Status && item.Status.Disk
                ? parseFloat(item.Status.Disk.UsedPercent * 100).toFixed(1) + '%'
                : '' }}
              </td>
              <th>磁盘使用详情</th>
              <td v-if="item.Status && item.Status.Disk">
                {{ Math.round(item.Status.Disk.Used / Math.pow(1024,3)) }}G /
                {{ Math.round(item.Status.Disk.Total / Math.pow(1024,3)) }}G
              </td>
              <td v-else>-</td>
            </tr>
            <tr>
              <th>C盘占用率</th>
              <td>
                {{ item.Status && item.Status.Disk
                ? parseFloat(item.Status.Disk.CUsedPercent * 100).toFixed(1) + '%'
                : '' }}
              </td>
              <th>C盘使用详情</th>
              <td v-if="item.Status && item.Status.Disk">
                {{ Math.round(item.Status.Disk.Cused / Math.pow(1024,3)) }}G /
                {{ Math.round(item.Status.Disk.Ctotal / Math.pow(1024,3)) }}G
              </td>
              <td v-else>-</td>
            </tr>
          </table>
        </el-tab-pane>
        <el-tab-pane label="备份信息">
          <div class="border-style">数据库信息</div>
          <el-table :data="item.DBFiles" v-loading="loading" size="medium">
            <el-table-column prop="LatestFilename" label="文件名称"></el-table-column>
            <el-table-column prop="FilePath" label="文件路径"></el-table-column>
            <el-table-column prop="LatestUpdateTime" label="生成时间">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.LatestUpdateTime"
                >{{ scope.row.LatestUpdateTime.substring(0,10) }}</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="border-style mar-t-md">文件信息</div>
          <el-table :data="item.IndexFiles" v-loading="loading" size="medium">
            <el-table-column prop="FileName" label="文件名称"></el-table-column>
            <el-table-column prop="Filesize" label="文件大小">
              <template slot-scope="{ row }">{{ (row.Filesize / 1024).toFixed(2) }}KB</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="日志信息">
          <div class="former pull-right">
            <el-select v-model="former.Logfile" clearable placeholder="请选择日志类型">
              <el-option label="应用程序" value="Application"></el-option>
              <el-option label="安全" value="Security"></el-option>
              <el-option label="系统" value="System"></el-option>
            </el-select>&nbsp;
            <el-select v-model="former.duration" clearable placeholder="请选择时间段">
              <el-option label="近7天" :value="-7"></el-option>
              <el-option label="近15天" :value="-15"></el-option>
              <el-option label="近30天" :value="-30"></el-option>
            </el-select>&nbsp;
            <el-button type="primary" @click="onDownload" title="导出">
              <i class="fas fa-download"></i>
            </el-button>
            <el-button type="primary" @click="onSubmitQuery" title="查询">
              <i class="fas fa-search"></i>
            </el-button>
          </div>
          <el-table :data="logList" v-loading="loading" size="medium">
            <el-table-column
              type="index"
              :index="pager.size * (pager.page - 1) + 1"
              :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)"
            ></el-table-column>
            <el-table-column prop="Logfile" label="日志文件"></el-table-column>
            <el-table-column prop="Type" label="类型"></el-table-column>
            <el-table-column prop="SourceName" label="来源"></el-table-column>
            <el-table-column prop="CreatedAt" label="生成时间">
              <template slot-scope="scope">
                <div v-if="scope.row.CreatedAt">{{ scope.row.CreatedAt.substring(0,10) }}</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="clearfix mar-top-10">
            <el-pagination
              class="pull-right"
              @current-change="onChangePage"
              layout="total, prev, pager, next"
              :total="pager.total"
              :current-page="pager.page"
              :page-size="pager.size"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-card>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      item: {},
      logList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        ServerStatusID: this.$route.params.ID,
        Logfile: '',
        duration: null,
      },
    };
  },
  mounted() {
    this.getItemData();
    this.getEventLog();
  },
  methods: {
    getItemData() {
      this.$axios.get(`serverstatus/${this.$route.params.ID}`, {
        params: {
          with: ['Platform'],
        },
      }).then((response) => {
        this.item = response.data;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    // 下载信息
    onDownload() {
      if (!this.former.duration) {
        this.$message.warning({
          showClose: true,
          message: '请选择导出时间段!',
        });
        return;
      }
      this.$axios.get(`data/serverstatus/${this.$route.params.ID}`,
        { responseType: 'blob' },
        { params: { duration: this.former.duration } })
        .then((response) => {
          this.autoDownloadBlobFile(
            new window.Blob([response.data], { type: 'data:text/csv;charset=utf-8' }),
            '服务器工作详情.xlsx'
          );
        }, (response) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 下载方法
    autoDownloadBlobFile(blob, fileName) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const anchor = window.document.createElement('a');
        anchor.href = window.URL.createObjectURL(blob);
        anchor.download = fileName;
        anchor.dispatchEvent(new window.MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        }));
      }
    },
    onSubmitQuery() {
      this.getEventLog();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getEventLog();
    },
    // 日志信息
    getEventLog() {
      this.loading = true;
      this.$axios.get('serverstatus/eventlog', {
        params: {
          where: _.omit(this.former, 'duration'),
          duration: this.former.duration,
          ...this.pager,
        },
      }).then((response) => {
        this.logList = response.data.data;
        this.pager = _.pick(response.data, 'size', 'page', 'total');
        this.loading = false;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ds-detail {
  .el-tabs__header {
    z-index: 0;
  }
  .fix-width {
    width: 120px;
  }
  table th td,
  table tr td {
    padding: 2px 5px;
    height: 30px;
    line-height: 30px;
  }
  table th {
    text-align: left;
    padding-left: 5px;
    color: #646566;
  }
  .border-style {
    height: 28px;
    line-height: 28px;
    border-radius: 0 15px 15px 0;
    border-left: 3px solid #cdcdcd;
    padding-left: 5px;
    margin-bottom: 10px;
    background-color: #ebf3f9;
    color: #646566;
  }
}
</style>
